import * as wordpress from '../wordpress'

export const settings = (state = null, { type, configuration }) =>
    type === wordpress.constants.CONFIGURATION_RECEIVED ? configuration.result.settings : state
